module.exports = __webpack_public_path__ + "static/media/FTS-BNB.96177977.svg";